import { render, staticRenderFns } from "./PaareTeams.vue?vue&type=template&id=c037ebda&scoped=true&"
import script from "./PaareTeams.vue?vue&type=script&lang=js&"
export * from "./PaareTeams.vue?vue&type=script&lang=js&"
import style0 from "./PaareTeams.vue?vue&type=style&index=0&id=c037ebda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c037ebda",
  null
  
)

export default component.exports